<template>
    <form action="" class="" v-on:submit.prevent="createFruit">
        <FormErrors :errors="vuelidate.$errors" />
        <InputComponent type="text" placeholder="Nombre" :value="vuelidate.fruit.name.$model" v-model="vuelidate.fruit.name.$model" />
        <InputComponent type="text" placeholder="Slug" :value="vuelidate.fruit.slug.$model" v-model="vuelidate.fruit.slug.$model" />
        <InputComponent type="textarea" placeholder="Descripción" :value="vuelidate.fruit.description.$model" v-model="vuelidate.fruit.description.$model" />
        <div class="p-5 my-8 border rounded-2xl border-light_gray bg-light_yellow">
            <h3 class="text-xl font-bold text-enriqueto_green">Ficha informativa</h3>
            <p class="mt-2 text-sm text-gray">Estos campos son opcionales. Solo la información completada aparecerá en la página pública del producto.</p>
            <InputComponent type="text" placeholder="Nombre científico" :value="vuelidate.fruit.scientific_name.$model" v-model="vuelidate.fruit.scientific_name.$model" />
            <InputComponent type="textarea" placeholder="Origen y distribución" :value="vuelidate.fruit.origin.$model" v-model="vuelidate.fruit.origin.$model" />
            <InputComponent type="textarea" placeholder="Temporada y disponibilidad" :value="vuelidate.fruit.seasonality.$model" v-model="vuelidate.fruit.seasonality.$model" />
            <InputComponent type="textarea" placeholder="Usos y aplicaciones" :value="vuelidate.fruit.uses.$model" v-model="vuelidate.fruit.uses.$model" />
            <InputComponent type="textarea" placeholder="Información nutricional" :value="vuelidate.fruit.nutritional_information.$model" v-model="vuelidate.fruit.nutritional_information.$model" />
            <InputComponent type="textarea" placeholder="Fuentes y referencias" :value="vuelidate.fruit.information_sources.$model" v-model="vuelidate.fruit.information_sources.$model" />
        </div>
        <InputComponent type="number" placeholder="Price" :value="vuelidate.fruit.price.$model" v-model="vuelidate.fruit.price.$model" />
        <InputComponent type="number" placeholder="Suministro" :value="vuelidate.fruit.supply.$model" v-model="vuelidate.fruit.supply.$model" />
        <InputComponent type="text" placeholder="Unidad" :value="vuelidate.fruit.unit.$model" v-model="vuelidate.fruit.unit.$model" />
        <SelectInput placeholder="Destacar" :items="[{id:'0',name:'no destacado'},{id:'1',name:'destacado'}]" :value="vuelidate.fruit.featured.$model" v-model="vuelidate.fruit.featured.$model" />
        <FileInput v-model="vuelidate.fruit.image.$model" accept=".pdf,.jpg,.jpeg,.png" />
        <SubmitButtonComponent value="Guardar"/>
    </form>
</template>

<script>
import { ref } from '@vue/reactivity'
import InputComponent from './InputComponent.vue'
import SubmitButtonComponent from './SubmitButtonComponent.vue'
import FormErrors from './FormErrors.vue'
import useVuelidate from '@vuelidate/core'
import { required,numeric } from '@vuelidate/validators'
import useApi from '../../Services/useApi'
import { Inertia } from '@inertiajs/inertia'
import FileInput from '../Forms/FileInput.vue'
import SelectInput from '../Forms/SelectInput.vue'
import useNotification from '../../Services/useNotification'

export default {
    components: {InputComponent,SubmitButtonComponent,FormErrors,FileInput,SelectInput,useNotification},
    props: ['fruit'],
    validations() {
        return {
            fruit: {
                name: {
                    required
                },
                slug:{},
                description: {
                    required
                },
                scientific_name: {},
                origin: {},
                seasonality: {},
                uses: {},
                nutritional_information: {},
                information_sources: {},
                price: {
                    required,numeric
                },
                supply: {
                    required,numeric
                },
                featured:{
                    required
                },
                unit:{
                    required
                },
                image:{
                    required
                }
            },
        }
    },
    setup(props,{emit}){
        const vuelidate = useVuelidate();
        const api = useApi();
        const fruit = ref({
            scientific_name: '',
            origin: '',
            seasonality: '',
            uses: '',
            nutritional_information: '',
            information_sources: '',
            ...props.fruit
        })
        const isEdit = Boolean(fruit.value.id)
        const notificate = useNotification()
        const image = fruit.value.image

        const createFruit = async()=>{
            let validation = await vuelidate.value.$validate();
            // form data
            let fileData = null
            if(image != fruit.value.image ){   
                fileData = new FormData()
                fileData.append('file', fruit.value.image)
            }
            if(validation){
                let apiCall = null
                if(isEdit){
                    apiCall = api.updateFruit(fruit.value,fileData)
                }else{
                    apiCall = api.addFruit(fruit.value,fileData)
                }
                apiCall.then(response=>{
                    console.log(response)
                    fruit.value = response.data.fruit
                    notificate.success('Guardado con exito')
                    Inertia.reload()
                    emit('added')
                })
            }else{
                notificate.error('Revisa el formulario')
            }
        }

        return{
            fruit,
            createFruit,
            vuelidate,
            isEdit
        }
    }
}
</script>

<style>

</style>
